import { Badge } from "reactstrap";
import { SidebarIconProp } from "../../../../Type/CustomizerType";
import CommonUL from "../../Common/CommonUL";
import { LI } from "../../../../AbstractElements";

const FillIcon = ({ handleSideBarIconType, sideBarIconType }: SidebarIconProp) => {
  return (
    <LI className={`border-0 ${sideBarIconType === "fill" ? "active" : ""}`} onClick={() => handleSideBarIconType("fill")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <div className="body bg-light">
          <Badge color="primary" className="badge badge-primary">Fill</Badge>
        </div>
      </div>
    </LI>
  );
};

export default FillIcon;
